<template>
  <div class="document">
    <h5 class="title is-5 is-orange has-text-left">
      Pending Work
    </h5>
    <div>
      <es-loader
        v-if="loading"
        style="margin: 1rem 0 0"
      />
      <es-exception
        v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        margin="1rem 0 0"
      />
      <table role="presentation"
        v-else
        class="table is-fullwidth"
      >
        <tbody>
          <tr v-if="hasModule('PRSID:MATCH:RESOLVENM:VIEW')">
            <td class="is-size-6 td-no-padding">
              Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }}(s/es)
            </td>
            <td class="has-text-right is-size-5 has-text-weight-bold">
              {{ pendingCounts.pendingNearMatches }}
            </td>
          </tr> 
          <tr class="no-bottom-border" v-if="hasModule('PRSID:MATCH:HISTORY:VIEW')">
            <td class="is-size-6 td-no-padding">
              Pending Batches
            </td>
            <td class="has-text-right is-size-5 has-text-weight-bold">
              {{ pendingCounts.pendingBatches }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  components: {
    EsException,
    EsLoader,
  },
  mixins: [
    PermissionManager,
  ],
  props: [
    'pendingCounts',
  ],
  data() {
    return {
      loading: false,
      loadingError: false,
    };
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
};
</script>

<style lang="sass" scoped>
  .document
    padding: 1rem
    height: 100%
  .title
    margin-bottom: .5rem
  .is-orange
    color: #C44A03
  .td-no-padding
    padding-left: 0
</style>
